module.exports = __webpack_public_path__ + "static/media/live19_10_2024.fd5c1a57.jpg";